import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.jpg";
import StoreButtons from "../components/StoreButtons";
import { PLAY_STORE_URL, APP_STORE_URL } from "../config";

export default function AppRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const ua = navigator.userAgent || "";
    const isAndroid = /android/i.test(ua);
    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const timer = setTimeout(() => {
      if (isAndroid) window.location.replace(PLAY_STORE_URL);
      else if (isIOS) window.location.replace(APP_STORE_URL);
      else navigate("/?descargar=1", { replace: true });
    }, 600);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="redirect-page" data-testid="app-redirect-page">
      <img src={logo} alt="Logo LleGO" className="redirect-logo" />
      <h1>Abriendo tu tienda…</h1>
      <p data-testid="redirect-status">Si no te redirige automáticamente, elegí tu plataforma:</p>
      <StoreButtons idPrefix="redirect" />
    </div>
  );
}
